import "../Content/bootstrap-faraz.scss";
import "../Content/bootstrap-faraz-rtl.scss"; //Keep 2nd
import "@framework/Frames/Frames.css";
import "@extensions/Workflow/Case/Inbox.css";
import "../Content/site.css";

import * as React from "react"
import { render, unmountComponentAtNode } from "react-dom"
import { Router, Route, Redirect, Switch } from "react-router"

import numbro from "numbro"
import * as moment from "moment" //jalaali

import { reloadTypes } from "@framework/Reflection"
import * as AppContext from "@framework/AppContext"
import * as Services from "@framework/Services"

import Notify from "@framework/Frames/Notify"
import ErrorModal from "@framework/Modals/ErrorModal"

import * as AuthClient from "@extensions/Authorization/AuthClient"
import * as CultureClient from "@extensions/Translation/CultureClient"
import * as LicenseClient from "@saturn/License/LicenseClient"
import * as PartyClient from "@saturn/Party/PartyClient"
import * as History from 'history'
import * as ConfigureReactWidgetsPersian from './ConfigureReactWidgetsPersian'
import { VersionChangedAlert } from "@framework/Frames/VersionChangedAlert";

import Layout from './Layout'
import Home from './Home'
import NotFound from './NotFound'
import FarazLogin from './FarazLogin'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FarazPermission } from "./Faraz/Faraz.Entities";

library.add(fas, far);

ConfigureReactWidgetsPersian.configure();

numbro.registerLanguage(require<any>("numbro/languages/en-GB"));
numbro.registerLanguage(require<any>("numbro/languages/fa-IR"));

declare var __webpack_public_path__: string;

__webpack_public_path__ = window.__baseUrl + "dist/";

var bootstrapFaraz: HTMLStyleElement;
var bootstrap: HTMLStyleElement;

function addRemove(style: HTMLStyleElement, isVisible: boolean) {
  if (isVisible && !style.parentNode) {
    let child = document.head!.getElementsByTagName("style")[1];
    document.head!.insertBefore(style, child);
  }
  else if (!isVisible && style.parentNode)
    style.parentNode.removeChild(style);
}

Notify.lockScreenOnLoading = true;

Services.VersionFilter.versionHasChanged = () => {
  VersionChangedAlert.forceUpdateSingletone && VersionChangedAlert.forceUpdateSingletone();
}

CultureClient.onCultureLoaded.push(ci => {
  var culture = ci.name;
  const rtlMode = culture.startsWith("fa");

  bootstrap = bootstrap || (bootstrap = document.head!.getElementsByTagName("style")[0]);
  bootstrapFaraz = bootstrapFaraz || (bootstrapFaraz = document.head!.getElementsByTagName("style")[1]);

  addRemove(bootstrap, !rtlMode);
  addRemove(bootstrapFaraz, rtlMode);

  AppContext.setRtl(rtlMode);

  if (rtlMode)
    document.body.classList.add("rtl");
  else
    document.body.classList.remove("rtl");

  if (culture == "en") {
    moment.locale("en-gb", {
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'YYYY/MM/DD',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
      },
    });
  }
  
  else if (culture == "fa") {
    moment.locale("fa", {
      longDateFormat: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'jYYYY/jMM/jDD',
      LL: 'jD jMMMM jYYYY',
      LLL: 'jD jMMMM jYYYY LT',
      LLLL: 'dddd، jD jMMMM jYYYY LT'
      },
    });
  }
  else
    throw new Error();
  
  numbro.setLanguage(culture == "en" ? "en-GB" : culture == "fa" ? "fa-IR" : "Unkwnown");
});

Services.NotifyPendingFilter.notifyPendingRequests = pending => {
  Notify.singleton && Notify.singleton.notifyPendingRequest(pending);
}

AuthClient.registerUserTicketAuthenticator();

window.onerror = (message: Event | string, filename?: string, lineno?: number, colno?: number, error?: Error) => ErrorModal.showAppropriateError(error);

function reload() {

  AppContext.clearAllSettings();

  return AuthClient.autoLogin()
    .then(() => LicenseClient.getLicensedModules())
    .then(() => LicenseClient.getLicenseInfo())
    .then(() => reloadTypes())
    .then(() => CultureClient.loadCurrentCulture())
    .then(() => {

      const productName = LicenseClient.licenseInfo.productName;

      Services.SessionSharing.setAppNameAndRequestSessionStorage(productName);

      var routes: JSX.Element[] = [];

      AuthClient.startPublic({ routes, userTicket: true, windowsAuthentication: false, resetPassword: false, notifyLogout: true });

      if (LicenseClient.isLicensed("SignUp")) {
        PartyClient.start({ routes });
        FarazLogin.customLoginButtons = () => PartyClient.getSignUpButtonComponent();
      }

      AppContext.setTitleFunction(pageTitle => document.title = (pageTitle ? (pageTitle + " - ") : "") + productName);
      AppContext.setTitle();

      routes[routes.findIndex(a => a.props.path == "~/auth/login")] = <Route exact path="~/auth/login" component={FarazLogin} />;

      const isFull = Boolean(AuthClient.currentUser()) && AuthClient.currentUser().userName != "Anonymous"; //true;

      var promise = isFull ?
        import("./MainAdmin").then(main => main.startFull(routes)) :
        Promise.resolve(undefined);

      return promise.then(() => {

        if (isFull) {
          routes.push(<Route exact path="~/" component={Home} />);
          routes.push(<Route component={NotFound} />);
        }
        else
          routes.push(<Redirect to="~/auth/login" />);

        Layout.switch = React.createElement(Switch, undefined, ...routes);
        const reactDiv = document.getElementById("reactDiv")!;
        unmountComponentAtNode(reactDiv);

        var h = AppContext.createAppRelativeHistory();

        render(
          <Router history={h}>
            <Layout />
          </Router>, reactDiv);

        return isFull;
      });
    });
}

AuthClient.Options.onLogin = (url?: string) => {
  reload()
    .then(() => import('@extensions/Workflow/WorkflowClient'))
    .then(workflowClient => {
      if (AuthClient.isPermissionAuthorized(FarazPermission.OpenInboxAsMainPage))

        AppContext.history.push(workflowClient.getDefaultInboxUrl());
      else {
        var loc = AppContext.history.location;
        var back: History.Location = loc && loc.state && (loc.state as any).back;
        AppContext.history.push(back ?? url ?? "~/");
      }

      AppContext.resetUI();
    }).done();
};

AuthClient.Options.onLogout = () => {
  AppContext.history.push("~/");
  reload().done();
};

reload().done();
